module.exports = __webpack_public_path__ + "img/Photo51.efe9f5f6.jpg";